/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectFinancialSummariesQuery } from '../../models/get-project-financial-summaries-query';
import { GetProjectFinancialSummariesQueryResult } from '../../models/get-project-financial-summaries-query-result';

export interface ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Params {
      body?: GetProjectFinancialSummariesQuery
}

export function apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectFinancialSummariesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectFinancialSummariesQueryResult>;
    })
  );
}

apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain.PATH = '/api/ProjectFinancialSummaries/GetProjectFinancialSummaries';
